import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { addParameterToUrl, getUrlParameter, replaceClientDataUrlRouteQueryVariables } from '@portal-internet/core';
import { useData } from 'hooks/useData';
import { useViewport } from 'hooks/3catinfo/useViewport';
import Boto from 'components/3catinfo/Boto';
import Destacat from 'components/3catinfo/Destacat';
import Titol from 'components/3catinfo/Titol';
import __isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';
import styles from './mosaic.module.scss';

const TitolMosaic = (props) => {
    const { titol, numItems } = props;
    const showTitle = numItems > 0;

    if (showTitle && !__isEmpty(titol)) {
        return <Titol titol={titol} tag='h2' />;
    }

    return <></>;
};

const getCurrentUrlPag = (url) => {
    return parseInt(getUrlParameter(url, 'pagina')) || 1;
};

const getUrlPage = (url, page) => {
    return addParameterToUrl(url, 'pagina', page);
};

export const MoreItemsButton = (props) => {
    const {
        mostrarBotoMesItems = false,
        urlCarregaDinamica,
        routerQuery,
        limitCarregaDinamica,
        setItemsDinamics,
        numItems,
        totalPagines,
        className
    } = props;
    const { data: itemsDinamic, paginacio, getDades } = useData();
    const url = replaceClientDataUrlRouteQueryVariables(urlCarregaDinamica, routerQuery);
    const [numPagLoadQuery, setNumPagLoadQuery] = useState(getCurrentUrlPag(url) + 1);
    const [showButtonDinamic, setShowButtonDinamic] = useState(numItems > 0 && totalPagines > 1);
    const [numPagesLoaded, setNumPagesLoaded] = useState(0);

    const loadMoreItems = () => {
        setNumPagesLoaded(numPagesLoaded + 1);
        getDades(getUrlPage(url, numPagLoadQuery));
    };

    useEffect(() => {
        if (!__isEmpty(itemsDinamic)) {
            const tieneInfoContingut =
                Array.isArray(itemsDinamic) && itemsDinamic.every((item) => item.hasOwnProperty('info_contingut'));
            if (tieneInfoContingut) {
                const bloquesInfoContingut = itemsDinamic.map((item) => item.info_contingut);
                setItemsDinamics(bloquesInfoContingut);
            } else {
                setItemsDinamics(itemsDinamic);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemsDinamic]);

    useEffect(() => {
        if (limitCarregaDinamica && numPagesLoaded >= limitCarregaDinamica) setShowButtonDinamic(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [numPagesLoaded]);

    useEffect(() => {
        if (!__isEmpty(paginacio) && paginacio.total_pagines) {
            if (paginacio.pagina_actual === paginacio.total_pagines) {
                setShowButtonDinamic(false);
            } else if (paginacio.pagina_actual < paginacio.total_pagines) {
                setNumPagLoadQuery(paginacio.pagina_actual + 1);
            }
        }
    }, [paginacio]);

    const stylesBtn = clsx({
        [styles.btnMoreItemsContent]: true,
        [className]: !!className
    });
    return mostrarBotoMesItems && urlCarregaDinamica && showButtonDinamic ? (
        <div className={stylesBtn}>
            <Boto
                tag='button'
                text="Mostra'n més"
                className={styles.btn}
                estil='transparent'
                icona='fletxa_simple_avall'
                mida='s'
                onClick={loadMoreItems}
            />
        </div>
    ) : (
        <></>
    );
};

const Mosaic = (props) => {
    const {
        numColumnsMobile,
        format,
        formatMobile,
        tipologia,
        className,
        estil,
        estilMosaic,
        mostraAfegirBookmark,
        mostraTematica,
        mostraRanking,
        tipus,
        showMissatgeEliminat,
        numColumns = false,
        hGap = 200,
        vGap = 200,
        elementsAMostrar = false,
        mostraComarca = false
    } = props;
    const router = useRouter();
    const { isOnlyMobile } = useViewport();
    const [itemsDinamics, setItemsDinamics] = useState([]);
    const [idNewItem, setIdNewItem] = useState(null);
    const [announcement, setAnnouncement] = useState('');
    const [toggleMessage, setToggleMessage] = useState(true);
    const [itemsToRemove, setItemsToRemove] = useState([]);

    const isChildrens = !__isEmpty(props.children);
    const itemsProps = props.items || [];
    const [items, setItems] = useState(props.children ? props.children : itemsProps);
    const formatDestacat = formatMobile && isOnlyMobile ? formatMobile : format;
    const columns = numColumnsMobile && isOnlyMobile ? numColumnsMobile : numColumns;

    useEffect(() => {
        setItemsDinamics([]);
    }, [router.asPath]);

    useEffect(() => {
        setItems(props.children ? props.children : props.items);
    }, [props.children, props.items]);

    if (!items) {
        return <></>;
    }

    const stylesContainerMosaic = clsx({
        [styles.contenidorMosaic]: true
    });

    const stylesMosaic = clsx({
        [styles.mosaic]: true,
        [className]: !!className,
        [styles.ranking]: mostraRanking,
        [styles[estilMosaic]]: !!estilMosaic,
        [styles[`column-gap-${hGap}`]]: !!hGap,
        [styles[`row-gap-${vGap}`]]: !!vGap,
        [styles[`columns-${columns}`]]: !className && !!columns
    });

    const suprimeixNoticia = async (isItemAlaMevaLlistaContext, id) => {
        if (!isItemAlaMevaLlistaContext) {
            setItemsToRemove((prev) => [...prev, id]);

            setTimeout(() => {
                setItems((prevItems) => prevItems.filter((item) => item.id !== id));
                setItemsDinamics((prevItems) => prevItems.filter((item) => item.id !== id));
                setItemsToRemove((prev) => prev.filter((itemId) => itemId !== id));
            }, 500); // Tiempo de espera para la animación antes de eliminarlo realmente

            //Re-estructuració per quan eliminem i no queden nés items en l'array principal d'items, s'ha d'emplenar amb la opció de dinamics
            if (items.length === 1 && items[0].id === id && itemsDinamics.length > 0) {
                setItems(itemsDinamics);
                setItemsDinamics([]);
            }
        }
    };

    const itemsToRender = () => {
        const _buildElement = (component, i) => {
            return !__isEmpty(component) && <div key={`mosaic-element-${i}`}>{component}</div>;
        };

        if (isChildrens) {
            return !__isEmpty(items)
                ? Array.from([...items.slice(0, elementsAMostrar || items.length)]).map((component, i) =>
                      _buildElement(component, i)
                  )
                : null;
        } else {
            if (!items || items.length === 0) return;

            return [...items.slice(0, elementsAMostrar || items.length), ...itemsDinamics].map((item, i) => {
                const itemId = item.id ?? i;

                return (
                    <div key={`mosaic-${format}-${itemId}`} className={itemsToRemove.includes(itemId) ? styles.eliminant : ''}>
                        <Destacat
                            {...props}
                            key={`mosaic-${format}-${itemId}`}
                            estil={estil}
                            format={formatDestacat}
                            tipologia={tipologia}
                            item={item}
                            inMosaic={true}
                            numColumnsRow={columns ? Math.round(12 / columns) : 12}
                            mostraAfegirBookmark={mostraAfegirBookmark}
                            accioMostraAfegirBookmark={suprimeixNoticia}
                            mostraTematica={mostraTematica}
                            tipus={tipus}
                            focusOnMount={itemId === idNewItem}
                            showMissatgeEliminat={showMissatgeEliminat}
                            mostraComarca={mostraComarca}
                        />
                    </div>
                );
            });
        }
    };

    return (
        <div data-testid='mosaic' className={stylesContainerMosaic}>
            <TitolMosaic {...props} numItems={items.length} />
            <div className={`${stylesMosaic} mosaic`}>{itemsToRender()}</div>
            <MoreItemsButton
                {...props}
                numItems={items.length}
                setItemsDinamics={(newItems) => {
                    setAnnouncement(toggleMessage ? "S'ha mostrat més contingut" : "S'ha carregat més contingut");
                    setToggleMessage(!toggleMessage);
                    setTimeout(() => {
                        setIdNewItem(newItems?.[0]?.id);
                        setItemsDinamics([...itemsDinamics, ...newItems]);
                        setAnnouncement('');
                    }, 100);
                }}
            />
            <div aria-live='assertive' className={styles.announcement} data-load={idNewItem}>
                {announcement}
            </div>
        </div>
    );
};

export default Mosaic;
